import { Stack, styled } from '@healthinal/ui';
import { HEADER_HEIGHT_PADDING_PX, theme } from '../theme.ts';

export const ContentSection = styled(Stack)({
  height: `calc(100vh - ${HEADER_HEIGHT_PADDING_PX}px)`,
  paddingBottom: theme.spacing(3),
  paddingRight: theme.spacing(3),
  overflowY: 'scroll',
});
